@switch (state()) {
  @case (ComponentState.LOADING) {
    <nz-row [nzJustify]="'center'">
      <nz-col>
        <nz-spin [nzSimple]="true" [nzSize]="'large'" />
      </nz-col>
    </nz-row>
  }
  @case (ComponentState.UNAUTHORIZED_ERROR) {
    <nz-row [nzJustify]="'center'">
      <nz-col [nzSpan]="24">
        <nz-result
          i18n-nzTitle="@@page-profile-content-session-expired-result-title"
          nzTitle="Session expired"
          i18n-nzSubTitle="
            @@page-profile-content-session-expired-result-subtitle"
          nzSubTitle="Wow, looks like the data may have been updated. Please, reload the page"
          [nzIcon]="'clock-circle'"
          [nzStatus]="'warning'" />
      </nz-col>
    </nz-row>
  }
  @case (ComponentState.UNEXPECTED_ERROR) {
    <nz-row [nzJustify]="'center'">
      <nz-col [nzSpan]="24">
        <nz-result
          i18n-nzTitle="@@page-profile-content-unexpected-error-result-title"
          nzTitle="Something's broken"
          i18n-nzSubTitle="
            @@page-profile-content-stories-unexpected-error-result-subtitle"
          nzSubTitle="Can't load stories. Please, reload the page or come back later"
          [nzIcon]="'close-circle'"
          [nzStatus]="'error'" />
      </nz-col>
    </nz-row>
  }
  @case (ComponentState.OK) {
    @let _storyDTOs = storyDTOs();
    <nz-row [nzJustify]="'center'">
      <nz-col [nzSpan]="24">
        @if (0 === _storyDTOs.length) {
          <nz-row [nzJustify]="'center'">
            <nz-col>
              <span nz-typography
                ><strong i18n="@@page-profile-content-stories-empty"
                  >The user doesn't have active stories</strong
                ></span
              >
            </nz-col>
          </nz-row>
        } @else {
          <nz-list nzGrid>
            <nz-row [nzGutter]="[8, 8]">
              @for (
                storyDTO of _storyDTOs;
                track storyDTO.primaryKey;
                let index = $index
              ) {
                <nz-col
                  [nzLg]="{ span: 6, offset: 0 }"
                  [nzMd]="{ span: 8, offset: 0 }"
                  [nzSm]="{ span: 12, offset: 0 }"
                  [nzXs]="{ span: 12, offset: 0 }">
                  <img
                    class="with-100 height-auto pointer"
                    nz-image
                    nz-tooltip
                    [nzTooltipTitle]="statisticsTemplate"
                    [nzTooltipTitleContext]="{
                      $implicit: {
                        userCount: getOtherUsers(storyDTO).length,
                        expiresAt: getExpiresAt(storyDTO),
                      },
                    }"
                    [nzTooltipPlacement]="'top'"
                    [nzTooltipColor]="'#1f2ade'"
                    (click)="onImageClick(_storyDTOs, index)"
                    [nzPlaceholder]="'assets/private/img/loading.svg'"
                    [nzFallback]="'assets/private/img/fallback.png'"
                    [nzDisablePreview]="true"
                    [alt]="storyDTO.primaryKey"
                    [nzSrc]="getThumbnailUrl(storyDTO)" />
                </nz-col>
              }
              <ng-template #statisticsTemplate let-context>
                <nz-row [nzGutter]="[16, 8]">
                  <nz-col>
                    <span nz-typography class="color-white">
                      <strong>
                        <nz-icon [nzType]="'delete'" [nzTheme]="'outline'" />
                        {{ context.expiresAt }}
                      </strong>
                    </span>
                  </nz-col>
                </nz-row>
                <nz-row [nzGutter]="[16, 8]">
                  <nz-col>
                    <span nz-typography class="color-white">
                      <strong>
                        <nz-icon [nzType]="'user'" [nzTheme]="'outline'" />
                        {{ context.userCount }}
                      </strong>
                    </span>
                  </nz-col>
                </nz-row>
              </ng-template>
            </nz-row>
          </nz-list>
        }
      </nz-col>
    </nz-row>
  }
}
